export default "__VITE_ASSET__277f08a5__"